<script>
  import { Title } from "t2c-components";

  export let title;
</script>

<div class="list">
  <div class="box">
    <div class="box-header line">
      <Title {title} />
      <slot name="actions" />
    </div>
    <slot name="content" />
  </div>
</div>

<style>
  .list {
    flex: 1;
    max-width: 800px;
    margin-bottom: 48px;
  }

  .box {
    flex: 1;
  }

  .box-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .line {
    border-bottom: 1px solid var(--blue-color);
  }
</style>
